import React from 'react';
import {collection, doc, setDoc, query, where, getDocs} from 'firebase/firestore';
import * as guestListData from '../guest-list.json';

export function AdminTools({database}) {
    function populateDatabase() {
        console.log('Starting Upload')

        guestListData.forEach(async(guest) => {
            const docRef = doc(collection(database, 'guest-list'));
            const payload = {
                ...guest,
                name: guest.name.toLowerCase()
            };
            
            await setDoc(docRef, payload);
            console.log(`Uploaded ${guest.name}`)
        });
    }

    async function downloadRsvps() {
        const guestListRef = collection(database, 'guest-list');
        const goingQuery = query(
            guestListRef,
            where('going', '==', 'true')
        );
        const notGoingQuery = query(
            guestListRef,
            where('going', '==', 'false')
        );
        const blankQuery = query(
            guestListRef,
            where('going', '==', '')
        );

        const [goingResult, notGoingResult, blankResult] = await Promise.all([
            getDocs(goingQuery),
            getDocs(notGoingQuery),
            getDocs(blankQuery)
        ]);

        const results = [...goingResult.docs, ...notGoingResult.docs, ...blankResult.docs].map((doc) => {
            const {name, going} = doc.data();

            return [name, going].join(',');
        });
        const csv = ['name, going', ...results].join('\n');
        const blob = new Blob([csv], {type: 'text/csv'});
        const link = document.createElement('a');

        link.href = URL.createObjectURL(blob);
        link.download = 'rsvp.csv';
        link.click();
        link.remove();
    }
    
    return (
        <div className='admin-tools-wrapper'>
            <div className='admin-tools'>
                <span>Admin Tools</span>
                <button disabled onClick={populateDatabase}>Populate Database</button>
                <button onClick={downloadRsvps}>Download RSVPs</button>
            </div>
        </div>
    );
}
